import { offersData } from "@/data/offers";
import { Title } from "@/components/common/typography/Title";
import { PrimaryButton } from "@/components/buttons/PrimaryButton";
import { Icon } from "@iconify/react";
import {
  refreshContactAnchorIfNeeded,
  saveContactIntent,
} from "@/lib/contact-intent";

type PriceSectionProps = {
  offer: typeof offersData.sharedOpenSpace;
};

export const PriceSection = ({ offer }: PriceSectionProps) => {
  const priceText = offer.priceLabel ?? `${offer.prix} €/mois`;

  return (
    <section className="flex flex-col gap-12 px-4 py-20 md:px-24 lg:px-48 xl:px-96">
      <Title title="Notre tarif" />

      <div className="rounded-lg bg-white p-8 shadow-md">
        <div className="mb-6 flex flex-col justify-between gap-4 lg:flex-row lg:items-center">
          <div className="flex items-center">
            <div className="mr-3 h-6 w-1 rounded-full bg-primary"></div>
            <h3 className="text-2xl font-bold text-black">{offer.name}</h3>
          </div>

          <div className="flex items-baseline">
            <span className="ml-2 text-3xl font-bold text-primary md:text-4xl">
              {priceText}
            </span>
          </div>
        </div>

        {offer.capacity && (
          <div className="mb-4 flex items-center gap-2">
            <Icon icon="mdi:account-group" className="h-5 w-5 text-gray-600" />
            <p className="text-gray-600">{offer.capacity}</p>
          </div>
        )}

        <div className="mb-6 flex flex-wrap gap-3">
          {["Fibre pro", "Sanitaires H & F", "Phone box"].map((feature) => (
            <div
              key={feature}
              className="flex items-center gap-2 rounded-full bg-[#FFF2F2] px-4 py-2 text-sm"
            >
              <Icon icon="mdi:check-circle" className="h-4 w-4 text-primary" />
              <span className="text-black">{feature}</span>
            </div>
          ))}
        </div>

        <div className="mb-4 flex flex-col gap-3 sm:flex-row">
          <PrimaryButton
            variant="black"
            text="Voir nos équipements"
            navigateTo="#equipments"
          />
          <PrimaryButton
            text="Nous contacter"
            navigateTo="#contact"
            onClick={() => {
              saveContactIntent({
                offerType: offer.contactOfferType,
                source: `offres-${offer.id}`,
              });
              refreshContactAnchorIfNeeded();
            }}
          />
        </div>
      </div>
    </section>
  );
};
